import Modal from "../../../general/js/modal";
import BaseComponent from '../../../general/js/base-component';
import gtm from '../../../general/js/gtm';

export default class ModalTriggerComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        this.targetFromChildren = this.refs.target;
        this.targetSelector = this.element.dataset.target;
        this.modalTarget = null;
        this.modal = null;
        this.gtmEvent = undefined;

        this.modalTarget = this.getFromChildren();
        if (!this.modalTarget) {
            this.modalTarget = this.getFromTarget();
        }

        if (!this.modalTarget) {
            throw new Error('modal target is not defined')
        }

        this.onClick = this.onClick.bind(this);

        this.init();
    }

    init() {
        this.element.addEventListener('click', this.onClick);
    }

    getFromTarget() {
        return document.querySelector(this.targetSelector);
    }

    getFromChildren() {
        return this.targetFromChildren;
    }

    onClick(e) {
        e.preventDefault();
        if (this.modal === null) {
            this.modal = Modal.create(this.modalTarget);
        }

        let gtmEvent = this.getGtmEvent();
        if (gtmEvent) {
            gtm.push(gtmEvent);
        }
        this.modal.open();
    }

    onDestroy() {
        this.element.removeEventListener('click', this.onClick);
        this.modal = null;
    }

    getGtmEvent() {
        if (this.gtmEvent === undefined) {
            let result = null;
            let gtmObject = this.modalTarget.getAttribute('data-gtm-event');
            if (gtmObject) {
                try {
                    result = JSON.parse(gtmObject);
                } catch (err) {
                    console.error(`Unable to parse data-gtm-event on element:`, this.modalTarget);
                }
            }

            this.gtmEvent = result;
        }

        return this.gtmEvent;
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/js/modal-trigger.component.js